import React from "react";

//components
import { FormEmailResetPassWord } from "@components/auth/ResetPassword";
import { AuthLogoHeader } from "@components/auth";

function LoginPage(props) {

  return (
    <div className="wrapper -loginPageV2">
      <AuthLogoHeader {...props} />
      <div className="login_panel">
        <FormEmailResetPassWord />
      </div>
    </div>
  );
}

export default LoginPage;